import { Modal, InputNumber, Form, Row, Col, Button, DatePicker, Avatar, Divider } from 'antd'
import React from 'react'
import { ButtonEx } from '../../../styles/button.style'
import _ from 'lodash'
import moment from 'moment'
import { useDeepEffect } from '../../../utils/hooks'
import { inputRule, dateRule } from '../../../utils/rules'

const UpdateHeroPo = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        datePriceStart: formData.datePriceStart ? moment(formData.datePriceStart) : null,
        datePriceEnd: formData.datePriceEnd ? moment(formData.datePriceEnd) : null,
        quota: formData.quota,
        minimum: formData.minimum,
        price: formData.price,
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          id: formData.id,
          datePriceStart: values.datePriceStart ? values.datePriceStart.toISOString() : null,
          datePriceEnd: values.datePriceEnd ? values.datePriceEnd.toISOString() : null,
          quota: values.quota,
          minimum: values.minimum,
          price: values.price,
        }
        onOk(data)
      }
    })
  }

  const disabledDate = (current) => current && current < moment().startOf('day')

  return (
    <Modal
      width={500}
      title="แก้ไขข้อมูล PO"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, padding: '10px 12px', background: '#f5f5f5', borderRadius: 6 }}>
        <Avatar src={formData.materialImage} size={40} icon="file" />
        <div>
          <div style={{ fontWeight: 600 }}>{formData.materialName}</div>
          <div style={{ color: '#888', fontSize: 12 }}>ผู้ประกาศ: {formData.heroName}</div>
        </div>
      </div>
      <Divider style={{ margin: '0 0 16px' }} />
      <Form onSubmit={onSubmit} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="วันที่ราคาเริ่ม">
              {getFieldDecorator('datePriceStart', dateRule)(
                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" disabledDate={disabledDate} />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="วันที่ราคาสิ้นสุด">
              {getFieldDecorator('datePriceEnd', dateRule)(
                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" disabledDate={disabledDate} />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="ยอดนับซื้อทั้งหมด">
              {getFieldDecorator('quota', inputRule)(
                <InputNumber style={{ width: '100%' }} min={0} />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="รับขั้นต่ำ">
              {getFieldDecorator('minimum', inputRule)(
                <InputNumber style={{ width: '100%' }} min={0} />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="ราคา/หน่วย">
              {getFieldDecorator('price', inputRule)(
                <InputNumber style={{ width: '100%' }} min={0} />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>Cancel</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              Update
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedUpdateHeroPo = Form.create({ name: 'UpdateHeroPo' })(UpdateHeroPo)
export default WrappedUpdateHeroPo
